import deepmerge from "deepmerge";
import { env } from "../env/env";

type Config = {
  coreBackendUrl: string;
  ssoFrontendUrl: string;
  assetsUrl: string;
  dromoLicenseKey: string;
  dromoSchemaId: string;
  datadogToken: string;
  heapId: string;
};

const defaults: Config = {
  coreBackendUrl:
    env.NX_PUBLIC_CORE_BACKEND_URL ||
    "https://api-staging.rights.massivemusic.dev",
  ssoFrontendUrl: "https://staging.auth.songtradr.dev",
  assetsUrl:
    env.NX_PUBLIC_ASSETS_URL ||
    "https://assets-staging.rights.massivemusic.dev",
  dromoLicenseKey: "86815799-8839-4e14-a289-334bde776f04",
  dromoSchemaId: "34d73ca7-f0f2-4294-9069-da0bfa930151",
  datadogToken: "pubc8c7b3b6c5f81587a5d929683b6d16a2",
  heapId: "801863570",
};

const development = deepmerge<Config>(defaults, {
  coreBackendUrl: env.NX_PUBLIC_CORE_BACKEND_URL || "http://localhost:3333",
});

const preview = deepmerge<Config>(defaults, {});

const staging = deepmerge<Config>(defaults, {});

const production = deepmerge<Config>(defaults, {
  coreBackendUrl:
    env.NX_PUBLIC_CORE_BACKEND_URL || "https://api.rights.massivemusic.com",
  ssoFrontendUrl: "https://auth.songtradr.com",
  assetsUrl:
    env.NX_PUBLIC_ASSETS_URL || "https://assets.rights.massivemusic.com",
  heapId: "3378886285",
});

/** Build-time Frontend Config
 *
 * Dispatched on `BUILD_CONFIGURATION` (injected by webpack per Nx configuration). Each build
 * configuration (e.g. `production`) spreads `defaults` and overrides what differs.
 * `env.X || fallback` lets CI-injected vars (e.g. PR preview backends) override at build time.
 *
 * See [env.ts](../env/env.ts) for `process.env` validation and when to use env vars instead.
 */
export const config = (
  {
    development,
    preview,
    staging,
    production,
  } satisfies Record<typeof BUILD_CONFIGURATION, Config>
)[BUILD_CONFIGURATION];
